export class ProvinceSearch {
    countryId: string;
  }